import * as React from 'react';

import { cn } from '@/lib/utils';

export interface LoaderProps {
  size?: 'sm' | 'md';
  label?: string;
  className?: string;
}

export function Loader({ size = 'md', label = 'Loading', className }: LoaderProps) {
  const dimension = size === 'sm' ? 'h-4 w-4 border-2' : 'h-8 w-8 border-[3px]';

  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={label}
      className={cn('inline-flex items-center justify-center', className)}
    >
      <span
        className={cn(
          'animate-spin rounded-full border-muted border-t-primary',
          dimension,
        )}
      />
      <span className="sr-only">{label}</span>
    </span>
  );
}
